import * as React from 'react'

const ShyHyphens: React.FC<{ text: string }> = ({ text }) => {
  if (text) {
    let token = text
      .replace(/[бвгджзклмнпрстфхцчшщbcdfghjklmnpqrstvwxz]/g, 's')
      .replace(/[аеёиоуыэюяaeiouy]/g, 'g')
      .replace(/[йьъ]/g, 'x')

    token = token
      .replace(/xgg/g, 'x-gg')
      .replace(/xgg/g, 'x-gg')
      .replace(/xgs/g, 'x-gs')
      .replace(/xsg/g, 'x-sg')
      .replace(/xss/g, 'x-ss')
      .replace(/gssssg/g, 'gss-ssg')
      .replace(/gsssg/g, 'gss-sg')
      .replace(/gsssg/g, 'gs-ssg')
      .replace(/sgsg/g, 'sg-sg')
      .replace(/gssg/g, 'gs-sg')
      .replace(/sggg/g, 'sg-gg')
      .replace(/sggs/g, 'sg-gs')

    for (let i = 0; i < token.length; i++) {
      if (token[i] === '-') {
        text = text.slice(0, i) + '\u00AD' + text.slice(i)
      }
    }
  }

  return <>{text}</>
}

export default ShyHyphens
